import type { IconNode } from '../types';

/**
 * @name door-closed-package
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTggMTN2MyIgLz4KICA8cGF0aCBkPSJNMTkgOVY1YTIgMiAwIDAwLTItMkg3YTIgMiAwIDAwLTIgMnYxNiIgLz4KICA8cGF0aCBkPSJNMiAyMWg4IiAvPgogIDxwYXRoIGQ9Ik05IDEyaC4wMSIgLz4KICA8cmVjdCB4PSIxNCIgeT0iMTMiIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHJ4PSIxIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/door-closed-package
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const DoorClosedPackage: IconNode = [
  ['path', { d: 'M18 13v3' }],
  ['path', { d: 'M19 9V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16' }],
  ['path', { d: 'M2 21h8' }],
  ['path', { d: 'M9 12h.01' }],
  ['rect', { x: '14', y: '13', width: '8', height: '8', rx: '1' }],
];

export default DoorClosedPackage;
